module.exports = __webpack_public_path__ + "static/media/private-comment.3b59a64b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/recorded/private-comment.png
// module id = 2006
// module chunks = 6